import { useMemo } from "react";

const RATING_ORDER = [
  "AAA",
  "AA+",
  "AA",
  "AA-",
  "A+",
  "A",
  "A-",
  "BBB+",
  "BBB",
  "BBB-",
  "BB+",
  "BB",
  "BB-",
  "B+",
  "B",
  "B-",
  "CCC+",
  "CCC",
  "CCC-",
  "CC",
  "C",
  "D",
];

const RATING_RANK = RATING_ORDER.reduce((acc, rating, index) => {
  acc[rating] = index;
  return acc;
}, {});

/**
 * Custom hook for sorting data by credit rating
 *
 * @param {Array} data - Array of data containing a rating field
 * @param {string} ratingField - Name of the field containing the rating (default: 'rating')
 * @returns {Array} Sorted data by credit rating
 *
 * @example
 * const sortedData = useRatingSorter(companies);
 * const sortedData = useRatingSorter(bonds, 'bondRating');
 */
const useRatingSorter = (data, ratingField = "rating") => {
  return useMemo(() => {
    if (!data?.length) return [];

    return [...data].sort((a, b) => {
      const ratingA = a[ratingField]?.toUpperCase();
      const ratingB = b[ratingField]?.toUpperCase();

      const rankA = RATING_RANK[ratingA] ?? 999;
      const rankB = RATING_RANK[ratingB] ?? 999;

      return rankA - rankB;
    });
  }, [data, ratingField]);
};

export default useRatingSorter;
